export default __webpack_public_path__ + "static/media/loader.ec2d0e69.svg";